"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LinkedPromos = require("./LinkedPromos");
Object.keys(_LinkedPromos).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LinkedPromos[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LinkedPromos[key];
    }
  });
});